/**
 * Tutorial guidato delle impostazioni Comunicazione.
 *
 * Un preparativo solo: il riquadro del servizio, che il passo dedicato apre per
 * mostrarne i campi. `stopCommunicationSettingsTour` lo richiude a fine giro, e solo
 * se ad aprirlo e' stato il tutorial. L'interruttore non si tocca: salva subito.
 */
const SCOPE = '[data-tour-scope="setting-communication"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

let opened = false;

const visible = selector => {
	const element = document.querySelector(selector);

	return !!element && element.getClientRects().length > 0;
};

/** Apre il riquadro del primo servizio, se non e' gia' aperto. */
function openFirst() {
	if (visible(at('settings'))) return;

	const toggle = document.querySelector(at('expand'));

	if (toggle) {
		opened = true;
		toggle.click();
	}
}

/** Richiude il riquadro aperto dal tutorial. */
export function stopCommunicationSettingsTour() {
	if (!opened) return;

	opened = false;

	if (visible(at('settings'))) {
		document.querySelector(at('expand'))?.click();
	}
}

export function createCommunicationSettingsTourSteps() {
	return [
		{
			body: 'Da qui passa WhatsApp: il collegamento con il numero aziendale che il gestionale usa per scrivere ai clienti - avvisi di spedizione, coupon, risposte in chat.',
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Il canale WhatsApp',
		},
		{
			body: "L'interruttore accende il servizio e salva subito. Acceso senza credenziali valide non fa danni ma nemmeno nulla: i messaggi partono solo se il collegamento con Meta e' completo.",
			key: 'table',
			placement: 'top',
			target: at('table'),
			title: 'Accendere il servizio',
		},
		{
			body: "Il piu' a inizio riga apre la configurazione, ed e' la parte delicata: App ID, App Secret, Phone ID e Account ID arrivano dalla console di Meta, mentre il token va generato come token permanente di un utente di sistema - quelli normali scadono, e quando scadono i messaggi smettono di partire senza dire niente.",
			before: stopCommunicationSettingsTour,
			key: 'expand',
			placement: 'right',
			target: at('expand'),
			timeout: 400,
			title: 'Aprire la configurazione',
		},
		{
			body: "Nel riquadro c'e' anche la data di scadenza da tenere d'occhio, il numero di telefono con il prefisso internazionale e soprattutto Operazioni: le tre cose per cui il gestionale puo' usare WhatsApp - avvisi di tracking, chat con il cliente, invio dei coupon. Quello che non spunti qui non viene mandato.",
			before: openFirst,
			key: 'settings',
			placement: 'right',
			target: at('settings'),
			timeout: 600,
			title: 'Credenziali e operazioni',
		},
	];
}
